function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useLoggedIn } from '@immediate_media/auth-utils';
import { useState, useEffect } from 'react';
import useFabricApi from './use-fabric-api'; // TODO: Probably pull this out to be called once from somewhere at the root
// level and passed in via the context API, similar to the SettingsContext

var useUserProfile = function useUserProfile() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      claims = _useState2[0],
      setClaims = _useState2[1];

  var fabricApi = useFabricApi();
  var isLoggedIn = useLoggedIn();
  useEffect(function () {
    var fetchClaims = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var unformattedClaims, _err$response, formattedClaims;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fabricApi.userAccounts.claims.filter();

              case 3:
                unformattedClaims = _context.sent;
                _context.next = 12;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (!(((_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401)) {
                  _context.next = 11;
                  break;
                }

                setClaims();
                return _context.abrupt("return");

              case 11:
                throw _context.t0;

              case 12:
                formattedClaims = unformattedClaims.reduce(function (accumulator, setting) {
                  var obj = accumulator;

                  try {
                    // Account for any JSON stringified values, such as the user avatar
                    obj[setting.type] = JSON.parse(setting.value);
                  } catch (e) {
                    obj[setting.type] = setting.value;
                  }

                  return obj;
                }, {});
                setClaims(formattedClaims);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function fetchClaims() {
        return _ref.apply(this, arguments);
      };
    }();

    if (isLoggedIn) {
      fetchClaims();
      return;
    }

    setClaims();
  }, [isLoggedIn]);
  return claims;
};

export default useUserProfile;